module.exports = __webpack_public_path__ + "1276fffee474f13f8441cc9c39dda813.svg";